import React from 'react';

export const OffenderReviewCard = (props) => (
	<li className="result-data">
      <dl className="general-info">
        <dt>name</dt>
        <dd className="body-bold">{props.FullName}&nbsp;&#47;&#47;&nbsp;</dd>
        <dt>age</dt>
        <dd className="body-bold">{props.Age},&nbsp;</dd>
        <dt>race</dt>
        <dd className="body-bold">{props.Race},&nbsp;</dd>
        <dt>sex</dt>
        <dd className="body-bold">{props.Gender}</dd>
      </dl>
      <dl className="secondary-info">
        <div>
          <dt>Alias:&nbsp;</dt>
          <dd>{props.Alias}</dd>
        </div>
        <div>
          <dt>Inmate ID #:&nbsp;</dt>
          <dd>{props.OffenderId}</dd>
        </div>
        <div>
          <dt>Location:&nbsp;</dt>
          <dd>{props.LocationName}</dd>
        </div>
        <div>
          <dt>Release Date:&nbsp;</dt>
          <dd>{props.ProjectedReleaseDate}</dd>
        </div>
        <div>
          <dt>Relationship to Visitor:&nbsp;</dt>
          <dd>{props.RelationshipToVisitor}</dd>
        </div>
      </dl>
    </li>
)


// WEBPACK FOOTER //
// ./src/components/OffenderReviewCard/OffenderReviewCard.js